export const SET_ADDRESS = 'SET_ADDRESS'
export const REMOVE_ADDRESS = 'REMOVE_ADDRESS'
export const SET_ADDRESS_MOD = 'SET_ADDRESS_MOD'
export const SET_ADDRESS_MAP = 'SET_ADDRESS_MAP'
export const SET_SELF_TAKING = 'SET_SELF_TAKING'
export const SET_DEF_ADDRESS = 'SET_DEF_ADDRESS'
export const SET_CHOOSEN_ADR = 'SET_CHOOSEN_ADR'